import { ArrowLeft } from 'lucide-react'
import { useCallback, type ReactNode } from 'react'

import { Logo } from '@/assets/img/Logo'
import { cn } from '../lib/utils'
import { MenuDrawer } from './menu-drawer.component'
import { Button } from './ui/button'

export interface HeaderProps {
	pageTitle: string
  sellerSelector?: ReactNode
	isDrawer?: boolean
	handleGoBack?: () => void
	nameSeller: string
	nameCompany: string
	versionApp: string
	showConnectionStatus?: boolean
	className?: string
}

export function Header({
	pageTitle,
  sellerSelector,
	isDrawer = false,
	handleGoBack,
	nameCompany,
	nameSeller,
	versionApp,
	showConnectionStatus = true,
	className,
}: HeaderProps) {

	const handleBackClick = useCallback(() => {
		if (handleGoBack) {
			handleGoBack()
		} else {
			window.history.back()
		}
	}, [handleGoBack])

	return (
		<header
			className={cn(
				"bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-700",
				"fixed top-0 left-0 right-0 z-50 shadow-sm transition-all duration-300",
				className
			)}
		>
			<div className="px-4">
				<div className="flex items-center justify-between md:max-w-(--breakpoint-2xl) mx-auto">
					<div className="flex items-center min-w-0">
						{isDrawer ? (
							<MenuDrawer
								nameCompany={nameCompany}
								nameSeller={nameSeller}
								versionApp={versionApp}
							/>
						) : (
							<Button
								variant="ghost"
								onClick={handleBackClick}
								className="mr-3 hover:bg-gray-100 h-14 dark:hover:bg-gray-800 transition-colors"
								aria-label="Voltar"
							>
								<ArrowLeft size={20} className="text-gray-700 dark:text-gray-300" />
							</Button>
						)}
					</div>

					<div className="flex-1 text-center px-4">
						<h1 className="font-semibold text-gray-900 dark:text-white text-base md:text-lg truncate">
							{pageTitle}
						</h1>
					</div>

					<div className="flex items-center gap-3">
						<div className="flex-shrink-0">
							<Logo width={48} height={20} />
						</div>
					</div>
				</div>
			  {sellerSelector}
			</div>
		</header>
	)
}